import { defineMessages } from 'react-intl';

export const translations = defineMessages({
    no_tech: {
        id: 'Developer.jobIssues.tech',
        defaultMessage: 'Not technical enough'
    },
    no_responsabilities: {
        id: 'Developer.jobIssues.responsabilities',
        defaultMessage: 'Not enough responsibilities'
    },
    no_challenge: {
        id: 'Developer.jobIssues.challenge',
        defaultMessage: 'Not enough challenge'
    },
    boring_team: {
        id: 'Developer.jobIssues.team',
        defaultMessage: 'Team issues'
    },
    boring_management: {
        id: 'Developer.jobIssues.management',
        defaultMessage: 'Management issues'
    },
    salary: {
        id: 'Developer.jobIssues.salary',
        defaultMessage: 'Low salary'
    },
    location: {
        id: 'Developer.jobIssues.location',
        defaultMessage: 'Location'
    },
    other: {
        id: 'Developer.jobIssues.other',
        defaultMessage: 'Other'
    }
});
